export function escapePath(path) {
  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  return path.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
